import { render, staticRenderFns } from "./HomeStatCards.vue?vue&type=template&id=5f5b3104&scoped=true"
import script from "./HomeStatCards.vue?vue&type=script&lang=js"
export * from "./HomeStatCards.vue?vue&type=script&lang=js"
import style0 from "./HomeStatCards.vue?vue&type=style&index=0&id=5f5b3104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5b3104",
  null
  
)

export default component.exports